<template>
  <div class="profile">
    <h1 class="title text-center">Profile</h1>
    <b-container>
      <b-row>
        <b-card class="col-md-12">
          <h4 class="text-center">Edit your profile</h4>

          <b-row class="mt-4">
            <div class="col-md-6 border-right">
              <h5>Personal Info</h5>

              <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(update_profile)">
                  <div class="mt-4">
                    <label for="name" class="text-secondary">Full name</label>

                    <ValidationProvider
                      name="name"
                      rules="required"
                      v-slot="{ errors, failed }"
                    >
                      <b-form-input
                        v-model="customer.name"
                        :class="failed ? 'error-input col-md-8' : 'col-md-8'"
                        name="name"
                      ></b-form-input>

                      <span class="form-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="mt-4">
                    <label for="email" class="text-secondary">Enter Email</label>

                    <ValidationProvider
                      name="email"
                      rules="required|email"
                      v-slot="{ errors, failed }"
                    >
                      <b-form-input
                        v-model="customer.email"
                        :class="failed ? 'error-input col-md-8' : 'col-md-8'"
                        name="email"
                      ></b-form-input>

                      <span class="form-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="mt-4">
                    <label for="contact" class="text-secondary">Enter Contact</label>

                    <ValidationProvider
                      name="contact"
                      rules="required"
                      v-slot="{ errors, failed }"
                    >
                      <b-form-input
                        v-model="customer.contact"
                        :class="failed ? 'error-input col-md-8' : 'col-md-8'"
                        name="contact"
                      ></b-form-input>

                      <span class="form-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="text-center mt-4">
                    <b-button type="submit" squared variant="outline-primary">Update</b-button>
                  </div>
                </b-form>
              </ValidationObserver>
            </div>

            <div class="col-md-6">
              <h5>Manage Addresses</h5>
              <b-link @click="show_address_modal"><font-awesome-icon icon="plus" /> New Address</b-link>

              <b-table v-if="table_items.length > 0" :items="table_items" :fields="table_headers">
                <template v-slot:cell(Action)="data">
                  <b-link class="text-danger" @click="remove_address(data.value)">
                    <font-awesome-icon icon="times" />
                  </b-link>
                </template>
              </b-table>
            </div>
          </b-row>
        </b-card>
      </b-row>
    </b-container>

    <b-modal ref="address-modal" title="Add New Address" hide-footer centered>
      <ValidationObserver ref="address_form" v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(create_address)">
          <label
            v-if="currentRestaurant.coverage_type == 'areas'"
            class="text-secondary"
          >Select Area</label>

          <label
            v-else
            class="text-secondary"
          >Search Place</label>

          <ValidationProvider
            rules="required"
            v-slot="{ errors, failed }"
          >

            <b-form-select
              v-if="currentRestaurant.coverage_type == 'areas'"
              v-model="query"
              :options="coverageAreaOptions"
              :class="{ 'error-input': failed }"
            ></b-form-select>

            <vue-bootstrap-typeahead
              v-else
              :data="places"
              v-model="query"
              :serializer="s => s.text"
              :class="{ 'error-input': failed }"
            />

            <span class="form-error">{{ errors[0] }}</span>
          </ValidationProvider>

          <b-row>
            <b-col>
              <text-input
                label_text="Enter Street"
                rules="required"
                input_name="street"
                class="mt-1"
              ></text-input>
            </b-col>

            <b-col>
              <text-input
                label_text="Enter Building"
                rules="required"
                input_name="building"
                class="mt-1"
              ></text-input>
            </b-col>
          </b-row>

          <text-input
            label_text="Enter Floor"
            rules="required"
            input_name="floor"
            class="mt-1"
          ></text-input>

          <ValidationProvider rules="required" v-slot="{ failed }">
            <label class="text-secondary">Address Type</label><span class="form-error">{{ failed ? '1 required' : ''}}</span>
            <b-form-radio v-model="address_type" value="home">Home</b-form-radio>
            <b-form-radio v-model="address_type" value="office">Office</b-form-radio>
          </ValidationProvider>

          <label class="text-secondary mt-3">Delivery Note</label>

          <b-row>
            <b-col class="mb-4">
              <p class="desc-note mb-1">Guide delivery boy to your location.</p>

              <b-form-textarea
                id="textarea"
                placeholder="Eg. Near water supply"
                v-model="deliveryNote"
                size="sm"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <b-button type="submit" squared variant="outline-primary" class="float-right mt-3">Create Address</b-button>
        </b-form>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import TextInput from '../components/text_input'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import _ from 'underscore'
import { mapGetters } from 'vuex'

const API_URL = `https://api.foursquare.com/v2/venues/suggestcompletion?ll=:lat,:lng&query=:query&client_id=${process.env.VUE_APP_FOURSQUARE_CLIENT_ID}&client_secret=${process.env.VUE_APP_FOURSQUARE_CLIENT_SECRET}`

export default {
  name: "profile",

  components: {
    'text-input': TextInput,
    'vue-bootstrap-typeahead': VueBootstrapTypeahead,
  },

  data() {
    return {
      customer: {
        name: '',
        email: '',
        contact: '',
      },
      address_type: '',
      table_headers: ['Address', 'For', { key: 'Action', class: 'text-center' }],
      table_items: [],
      places: [],
      query: '',
      currentLocation: {},
      deliveryNote: '',
    }
  },

  created() {
    this.$store.dispatch('getRestaurant')
    if (navigator.geolocation)
      navigator.geolocation.getCurrentPosition(
        response => { this.currentLocation = response.coords },
        error => { alert('Allow to access your location.') }
      )
    this.$store.dispatch("show_profile")
      .then(response => {
        this.customer.name = response.data.attributes.name
        this.customer.email = response.data.attributes.email
        this.customer.contact = response.data.attributes.contact
        response.data.attributes.addresses.map((value, key) => {
          this.table_items.push({ Address: this.complete_address(value), For: this.capitalize(value.address_type), Action: value.id })
        })
      })
  },

  computed: {
    ...mapGetters(['currentRestaurant']),
    coverageAreaOptions() {
      return this.currentRestaurant.coverage_areas.map((coverageArea, index) => {
        return {
          value: coverageArea.name,
          text: coverageArea.name
        }
      })
    },
    complete_address() {
      return address => [address.street, address.building, address.floor, address.area].join(', ')
    }
  },

  watch: {
    query: _.debounce(function(searchQuery) {
      if (searchQuery != "")
        this.fetchPlaces(searchQuery)
    }, 500)
  },

  methods: {
    async fetchPlaces(query) {
      const result = await fetch(this.getApiUrl(query))
      const suggestions = await result.json()
      this.places = suggestions.response.minivenues.map((minivenue) => {
        if (minivenue.location.address != undefined)
          return { text: `${minivenue.name}, ${minivenue.location.city}` }
        else
          return { text: minivenue.name }
      })
    },

    update_profile() {
      this.$store.dispatch('update_profile', this.customer)
        .then(response => {
          this.$notify({
            type: 'success',
            text: 'Profile updated successfully!'
          })
        })
        .catch(error => {
          this.$refs.form.setErrors(error.data.errors)
          console.log(error)
        })
    },
    show_address_modal() {
      this.$refs['address-modal'].show()
    },
    create_address() {
      this.$store.dispatch('create_address', {
        area: this.$refs['address_form'].$children[0].value,
        street: this.$refs['address_form'].$children[1].value,
        building: this.$refs['address_form'].$children[2].value,
        floor: this.$refs['address_form'].$children[3].value,
        latitude: this.currentLocation.latitude,
        longitude: this.currentLocation.longitude,
        delivery_note: this.deliveryNote,
        address_type: this.address_type
      })
        .then(response => {
          this.table_items.push({ Address: this.complete_address(response.attributes), For: this.capitalize(response.attributes.address_type), Action: response.id })
          this.$refs['address-modal'].hide()
          this.$notify({
            type: 'success',
            text: 'Address successfully added.'
          })
          this.address_type = ''
          this.deliveryNote = ''
        })
        .catch(error => {
          console.log(error)
        })
    },
    remove_address(address_id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      })
        .then((result) => {
          if (result.value) {
            this.$store.dispatch("remove_address", address_id)
              .then(response => {
                this.$swal('Removed!', 'Address has been removed successfully.', 'success')
                this.table_items = []
                response.data.map((value, key) => {
                  this.table_items.push({ Address: this.complete_address(value.attributes), For: this.capitalize(value.attributes.address_type), Action: value.id })
                })
              })
              .catch(error => {
                this.$notify({
                  type: 'error',
                  text: 'You\'re unable to delete this address'
                })
              })
          }
        })
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    getApiUrl(query) {
      return API_URL.replace(':query', query).replace(':lat', this.currentLocation.latitude).replace(':lng', this.currentLocation.longitude)
    },
  },

  beforeCreate: function() {
    document.body.className = '';
  },
}
</script>

<style scoped>
  .blue-gradient {
    background: linear-gradient(40deg, #979fff, #5663FF);
    border: 0;
  }
  .btn {
    height: 40px;
    width: 150px;
  }
  .btn-outline-primary {
    color: #5663FF;
    border-color: #5663FF;
    background-color: white;
    box-shadow: none;
  }
  .btn-outline-primary:hover {
    color: white;
    border-color: #5663FF;
    background-color: #5663FF;
  }
  .form-error {
    color: #D9534F;
    padding: 5px;
  }
  .error-input {
    border: 1px solid #D9534F;
    border-radius: 5px;
  }
</style>
